import {
  useGetBackDocumentaleFascicoliId,
  useGetBackDocumentaleFascicoliIdDocumenti,
} from '@framework/api-client';

const DOCUMENTAL_AUTH_TOKEN_HEADER = 'Authorization-Fascicoli';

interface IDocumentDossierQueryOptions {
  documentalToken: string;
  enabled?: boolean | undefined;
}

/**
 * Ottieni i dati di un fascicolo e dei documenti ad esso collegati.
 */
export function useDocumentDossierQuery(
  dossierId: string | null | undefined,
  options: IDocumentDossierQueryOptions,
) {
  const dossierResult = useGetBackDocumentaleFascicoliId(dossierId ?? '', {
    query: { enabled: dossierId != null && options.enabled },
    request: {
      headers: { [DOCUMENTAL_AUTH_TOKEN_HEADER]: `${options.documentalToken}` },
    },
  });

  const documentsResult = useGetBackDocumentaleFascicoliIdDocumenti(
    dossierId!,
    {
      query: { enabled: dossierId != null && options.enabled },
      request: {
        headers: {
          [DOCUMENTAL_AUTH_TOKEN_HEADER]: `${options.documentalToken}`,
        },
      },
    },
  );

  return {
    isLoading: dossierResult.isLoading || documentsResult.isLoading,
    isFetching: dossierResult.isFetching || documentsResult.isFetching,
    error: dossierResult.error ?? documentsResult.error,
    dossier: dossierResult.data?.data,
    documents: documentsResult.data?.data?.documentiFascicolo,
    documentDownloadToken: documentsResult.data?.data?.tokenDocumentiFascicolo,
  };
}
